var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNyt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.8 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nytsvg",
    d: "M13.8,2.5c0-2-1.9-2.5-3.4-2.5V.3c.9,0,1.6.3,1.6,1a1.06,1.06,0,0,1-1.2,1,13,13,0,0,1-3.3-.8A10.63,10.63,0,0,0,4,.6,3.27,3.27,0,0,0,.6,3.8,2.32,2.32,0,0,0,2.1,6l.1-.2a1.2,1.2,0,0,1-.5-1A1.27,1.27,0,0,1,3.1,3.7a14.78,14.78,0,0,1,3.7.9,28.26,28.26,0,0,0,3.7.8V8.5L9,9.8v.1l1.5,1.3v4.3a4.62,4.62,0,0,1-2.5.6,4.93,4.93,0,0,1-3.9-1.6l4.1-2V5.6l-5,2.2A5.1,5.1,0,0,1,5.8,5l-.1-.3a7.59,7.59,0,0,0-5.7,7,7,7,0,0,0,7,7,6.51,6.51,0,0,0,6.6-6.5h-.2a6.7,6.7,0,0,1-2.6,3.1V11.2l1.6-1.3V9.8L10.8,8.5V5.4A2.86,2.86,0,0,0,13.8,2.5Zm-8.7,11-1.2.6a5.93,5.93,0,0,1-1.1-3.8A7.14,7.14,0,0,1,3,8.2l2.1-.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyt);
export default __webpack_public_path__ + "static/media/nyt.c0d7b6a4c6237b807d16811610c09830.svg";
export { ForwardRef as ReactComponent };